import { FunctionalComponent } from 'preact'
import Button from '../../control-components/ui-components/Button'

interface ShowMoreButtonProps {
  href: string
  label: string
}

const ShowMoreButton: FunctionalComponent<ShowMoreButtonProps> = ({
  href,
  label
}) => {
  const external =
    typeof window !== 'undefined' && !href.includes(window.location.hostname)

  if (external) {
    return (
      <a
        class='featured-topics__show-more-button'
        href={href}
        target='_blank'
        rel='noreferrer nofollow noopener'
      >
        <Button title={label} />
      </a>
    )
  }
  return (
    <a class='featured-topics__show-more-button' href={href}>
      <Button title={label} />
    </a>
  )
}

export default ShowMoreButton
